// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1330":"6805acc2f1b8b4b7","2888":"7166fc70cd298307"}[chunkId] + ".css";
};